var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVenmoLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.1097 2.15118C8.37333 2.73496 8.49877 3.37168 8.47628 4.01183C8.47628 5.52256 7.40433 7.74423 6.53787 9.16054L5.62699 1.69018L1.78906 2.0512L3.54973 12.5541H7.92642C9.8426 10.0325 12.2087 6.44455 12.2087 3.66747C12.2308 2.88563 12.0264 2.11407 11.6199 1.4458L8.1097 2.15118Z",
    fill: "#008CFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVenmoLogo);
export default __webpack_public_path__ + "static/media/venmo_logo.16fd9f7c654c067096cb585d0a18e997.svg";
export { ForwardRef as ReactComponent };